'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'GRID_01',
	name: 'Grid',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*', '!CELL_*'],
	category: 'Layout',
	props: [{
		name: 'gutter',
		inputType: 'checkbox',
		label: 'Gutter',
		default: true
	}, {
		name: 'equalHeight',
		inputType: 'checkbox',
		label: 'Set same height on all cells',
		default: false
	}, {
		name: 'grid-cells',
		inputType: 'grid',
		label: 'Grid',
		default: '[{"size":"4of12","md-size":"4of12","lg-size":"4of12"},{"size":"4of12","md-size":"4of12","lg-size":"4of12"},{"size":"4of12","md-size":"4of12","lg-size":"4of12"}]'
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
		label: 'Alignment',
		props: [{
			name: 'vertical',
			inputType: 'select',
			label: 'Vertical alignment',
			default: 'top',
			values: ['top', 'middle', 'bottom']
		}, {
			name: 'horizontal',
			inputType: 'select',
			label: 'Horizontal alignment',
			default: 'left',
			values: ['left', 'center', 'right']
		}]
	})
};